import "./button.scss";

function Button() {
  return (
    <div className="button-box">
      <button className="button">SHOP NOW</button>
    </div>
  );
}

export default Button;
